import { createSlice } from "@reduxjs/toolkit";
import { TodoSliceEntity } from "../type/Presenter";

const initialState: TodoSliceEntity = {
  data: [],
  loading: false,
  currentPage: 1,
  pageSize: 0,
  isRefreshCR003: false,
  fileName: "",
  fileLink: ""
};

export const todoSlice = createSlice({
  name: "todo",
  initialState,
  reducers: {
    setTodoList: (state, action) => {
      state.data = action.payload;
    },
    refreshCR003: (state) => {
      state.isRefreshCR003 = !state.isRefreshCR003;
    },
    setFileName: (state, action) => {
      state.fileName = action.payload;
    },
    setFileLink: (state, action) => {
      state.fileLink = action.payload;
    },
  },
});

export const { setTodoList, refreshCR003, setFileName, setFileLink } = todoSlice.actions;

export default todoSlice.reducer;
